import { $, $$, reducedMotion } from '@utils';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-toggle-video]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-play-pause-btn]').forEach((btn) => {
    btn.addEventListener('click', toggleVideo);

    if (reducedMotion.matches) {
      isReducedMotion(btn);
      reducedMotion.addEventListener('change', () => isReducedMotion(btn));
    }
  });
}

function toggleVideo(e) {
  const button = e.target;
  const icon = button.querySelector('[data-au-icon]');
  const label = button.querySelector('[data-au-hidden-label]');
  const video = button.parentNode.querySelector('[data-au-toggle-video]');
  const toggleVideoParent = button.closest('[data-au-toggle-video-parent]');
  const module = toggleVideoParent || button.closest('section');
  const title = toggleVideoParent
    ? toggleVideoParent.querySelector('[data-au-toggle-video-title]')
    : module
      ? module.querySelector('.au-active [data-au-title]') ||
        module.querySelector('.swiper-slide-active [data-au-title]')
      : '';
  const titleText = title ? title.innerText : '';

  if (icon.innerText === 'pause') {
    icon.innerText = 'play_arrow';
    label.innerText = button.dataset.auPlayText;
    video.pause();

    datalayerPushGeneric(e, 'navigation', 'clickVideo', titleText, button.dataset.auPauseText);
    return;
  }

  icon.innerText = 'pause';
  label.innerText = button.dataset.auPauseText;
  video.play();

  datalayerPushGeneric(e, 'navigation', 'clickVideo', titleText, button.dataset.auPlayText);
}

function isReducedMotion(btn) {
  const video = btn.parentNode.querySelector('[data-au-toggle-video]');
  btn.querySelector('[data-au-icon]').innerText = 'play_arrow';
  btn.querySelector('[data-au-hidden-label]').innerText = btn.dataset.auPlayText;
  if (video) video.pause();
}

export default { init };
